import styled from 'styled-components'

export const Wrapper = styled.div`
    background: #222;
    color: #fff;
    padding: 1.5rem;
    bottom: 0;
    margin-top: auto;
`
